import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';
import '../abouts.css';
import Dynamicmeta from "./Dynamicmeta";

const AboutUs = () => {
  return (
    <>
      {/* Header Section */}
      <Dynamicmeta/>
      <Header />
      <div id="about-main-div">
      <header id="header" className="header">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-container text-center">
                <img src="/graphics/images/favicon.webp" className="rounded myshadow" alt="CodeInputs" style={{ height: '6rem' }} />
                <h1 className="h1-large mt-5 text-white">Welcome To CODE INPUTS</h1>
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      {/* Services Section */}
      <section className="" id="distinct">
        <Container>
          <Row>
            {services.map((service, index) => (
              <Col md={6} key={index} className="text-center expert-opt">
                <Card>
                  <div className="image">
                    <img src={service.image} alt={service.title} width="100%" />
                    <h6 className="head-center mt-3">{service.title}</h6>
                  </div>
                  <Card.Body>
                    <Card.Text className="content">{service.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}

              <Col md={6} key="4" className="text-center mb-4">
                <Card>
                  <div className="image">
                    <img src="/graphics/images/our_expertise.webp" alt="OUR EXPERTISE" width="100%" />
                    <h6 className="head-center mt-3">OUR EXPERTISE</h6>
                  </div>
                  <Card.Body>
                    <Card.Text className="content"><ul><li>Billing Software</li>
                    <li>Inventory Management</li><li>Finance Management</li><li>MLM Management System</li></ul></Card.Text>
                  </Card.Body>
                </Card>
              </Col>
          </Row>
        </Container>
      

      {/* About Section */}
      <Container id="about" className="bg-white p-4 border border-1 mb-5 shadow p-3 mb-5 bg-body rounded">
       
            <h2 className="text-center">About Us</h2>
            <p>Welcome to Codeinputs, a dedicated team of freelance professionals passionate about delivering top-notch IT solutions. With expertise in software development, website development, and mobile application development, we bring innovative ideas to life through technology.</p>
            <h4>Our Mission</h4>
            <p>Our mission is to provide high-quality IT services that cater to the unique needs of businesses, startups, and individuals. We strive to make the digital transformation journey seamless, ensuring every solution we deliver is tailored to enhance efficiency, usability, and success.</p>
            <p>In addition to our IT services, we love giving back to the community by providing useful tools that make everyday tasks easier. On our website, you'll find our tools.</p>
            <p>As freelancers, we pride ourselves on offering a personalized and flexible approach to every project. We work closely with you, ensuring that your vision is transformed into reality while maintaining high standards of quality and professionalism.</p>
            <h4>Our Vision</h4>
            <p>Empowering businesses and individuals with innovative software solutions, cutting-edge web development, and insightful technical resources. At CodeInputs.com, we envision a future where technology is accessible, efficient, and tailored to drive success. Our mission is to bridge the gap between ideas and implementation, fostering a digital ecosystem that thrives on creativity, security, and performance.</p>
        
      </Container>
      </section>
      </div>
      <Footer />
    </>
  );
};

const services = [
  {
    title: "WEB DEVELOPMENT",
    image: "/graphics/images/web-development.webp",
    description: "At Code Inputs, we specialize in creating stunning, high-performance websites tailored to meet your business needs. Whether you’re looking to build a brand-new site or revamp an existing one, our expert team is here to help you achieve your goals with innovative solutions and exceptional service."
  },
  {
    title: "SOFTWARE DEVELOPMENT",
    image: "/graphics/images/software-development.webp",
    description: "At Code Inputs, we provide cutting-edge software solutions designed to meet your unique business needs. Our team of experienced developers and tech experts is dedicated to delivering high-quality, scalable software that drives innovation and efficiency."
  },
  {
    title: "BLOG CREATION",
    image: "/graphics/images/blog-creations.webp",
    description: "At Code Inputs, we specialize in crafting engaging, high-quality blogs that resonate with your audience and enhance your brand’s online presence. Our team of experienced content creators and strategists is dedicated to delivering blog solutions that drive traffic, build authority, and foster engagement."
  }
];

export default AboutUs;
